import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { WeekHeader } from './WeekHeader';
import { DateUtils } from '../../utils/DateUtils';
import { Week } from './Week';

export class Month extends PureComponent {
    render() {
        const { displayMonth, weekStartsOn } = this.props;
        const firstDayOfMonth = DateUtils.getFirstDayOfMonth(displayMonth);
        const lastDayOfMonth = DateUtils.getLastDayOfMonth(displayMonth);
        let weekStart = DateUtils.getFirstDayOfWeek(firstDayOfMonth, weekStartsOn);

        const weeks = [];
        while (DateUtils.compare(weekStart, lastDayOfMonth) > -1 && weeks.length < 7) {
            weeks.push(<Week key={weekStart} start={weekStart} />);
            weekStart = DateUtils.add(weekStart, 7);
        }

        return (
            <div className="odf-calendar-month">
                <WeekHeader />
                {weeks}
            </div>
        );
    }
}

Month.propTypes = {
    displayMonth: PropTypes.instanceOf(Date).isRequired,
    weekStartsOn: PropTypes.number.isRequired,
};
